import { render } from "./PartnerEmployerDocuments.vue?vue&type=template&id=0c3ff9de&scoped=true"
import script from "./PartnerEmployerDocuments.vue?vue&type=script&lang=js"
export * from "./PartnerEmployerDocuments.vue?vue&type=script&lang=js"

import "./PartnerEmployerDocuments.vue?vue&type=style&index=0&id=0c3ff9de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3ff9de"]])

export default __exports__